module.exports = __webpack_public_path__ + "static/media/grocery-icon.d68fc990.svg";